"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const bullet_1 = __importDefault(require("./bullet"));
const defaults_1 = require("./defaults");
const image_object_1 = __importDefault(require("./image-object"));
const phase_1 = __importDefault(require("./phase"));
const video_1 = __importDefault(require("./video"));
class Habit extends base_1.default {
    constructor(data = {
        id: undefined,
        title: undefined,
        subtitle: undefined,
        icon: undefined,
        primary_color: undefined,
        secondary_color: undefined,
        commitments: undefined,
        background_image: undefined,
        video_title: undefined,
        video: undefined,
        minutes_per_day: undefined,
        days_to_complete: undefined,
        bullets_title: undefined,
        bullets: [],
        overview: undefined,
        order: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.title = (0, defaults_1.defaultString)(data.title);
        this.subtitle = (0, defaults_1.defaultString)(data.subtitle);
        this.icon = new image_object_1.default((0, defaults_1.defaultObject)(data.icon));
        this.background_image = new image_object_1.default((0, defaults_1.defaultObject)(data.background_image));
        this.primary_color = (0, defaults_1.defaultString)(data.primary_color);
        this.secondary_color = (0, defaults_1.defaultString)(data.secondary_color);
        this.commitments = (0, defaults_1.defaultArray)(data.commitments);
        this.video_title = (0, defaults_1.defaultString)(data.video_title);
        this.video = new video_1.default((0, defaults_1.defaultObject)(data.video));
        this.minutes_per_day = (0, defaults_1.defaultNumber)(data.minutes_per_day);
        this.days_to_complete = (0, defaults_1.defaultNumber)(data.days_to_complete);
        this.bullets_title = (0, defaults_1.defaultString)(data.bullets_title);
        this.bullets = data.bullets.map((bul) => new bullet_1.default(bul));
        this.overview = new phase_1.default((0, defaults_1.defaultObject)(data.overview));
        this.order = (0, defaults_1.defaultNumber)(data.order);
    }
    get backgroundImage() {
        return this.background_image;
    }
    get primaryColor() {
        return this.primary_color;
    }
    get secondaryColor() {
        return this.secondary_color;
    }
    get minutesPerDay() {
        return this.minutes_per_day;
    }
    get daysToComplete() {
        return this.days_to_complete;
    }
    get videoTitle() {
        return this.video_title;
    }
    get bulletsTitle() {
        return this.bullets_title;
    }
}
exports.default = Habit;
